import {
    BookOpen,
    Briefcase,
    Calendar,
    FileText,
    Globe,
    GraduationCap,
    HeadphonesIcon,
    HelpCircle,
    type LucideIcon,
    Mail,
    MessageCircle,
    Send,
    Star,
    Users,
    Video,
    Wrench,
    Zap,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
    BookOpen,
    Briefcase,
    Calendar,
    FileText,
    Globe,
    GraduationCap,
    HeadphonesIcon,
    HelpCircle,
    Mail,
    MessageCircle,
    Send,
    Star,
    Users,
    Video,
    Wrench,
    Zap,
};

export const getIconByName = (name: string): LucideIcon | null => {
    return iconMap[name] ?? null;
};
